module.exports = __webpack_public_path__ + "img/small-corporate-customer-agreement.7d15a59a.svg";